module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "dnnCloud-admin-box",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-input', {
          attrs: {
            "placeholder": "姓名"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getUser(1)
            }
          },
          model: {
            value: (_vm.souchs.name),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "name", $$v)
            },
            expression: "souchs.name"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getUser(1)
            }
          }
        }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          staticClass: "adds",
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": _vm.handleAdd
          }
        }, [_vm._v("新增")])], 1)], 1)], 1)]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('el-table', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (_vm.listLoading),
            expression: "listLoading"
          }],
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": _vm.users,
            "highlight-current-row": "",
            "height": _vm.maxTbHeight,
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "selection-change": _vm.selsChange,
            "sort-change": _vm.handleSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod,
            "label": "序号",
            "width": "100"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "phone",
            "label": "账号",
            "min-width": "180",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "姓名",
            "min-width": "220",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "类型",
            "min-width": "220",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.type == '1' ? '系统管理员' : scope.row.type == '2' ? '客户经理' : scope.row.type == '3' ? '客户成功经理' : scope.row.type == '4' ? '经销商' : ''))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "intime",
            "label": "添加日期",
            "min-width": "180",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          staticStyle: {
            "text-algin": "center"
          },
          attrs: {
            "label": "操作",
            "min-width": "220"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "operate"
              }, [_c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "编辑",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconEdit",
                on: {
                  "click": function($event) {
                    return _vm.handleEdit(scope.$index, scope.row)
                  }
                }
              })]), _vm._v(" "), (!scope.row.delShow) ? _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "删除",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont icondelete",
                on: {
                  "click": function($event) {
                    return _vm.handleDel(scope.$index, scope.row)
                  }
                }
              })]) : _vm._e()], 1)]
            }
          }])
        })], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "新增",
            "visible": _vm.addFormVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.addFormVisible = $event
            },
            "closed": _vm.closeAddform
          }
        }, [_c('el-form', {
          ref: "addForm",
          attrs: {
            "model": _vm.addForm,
            "label-width": "80px",
            "rules": _vm.addFormRules
          }
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "账号",
            "prop": "user"
          }
        }, [_c('el-input', {
          attrs: {
            "auto-complete": "off",
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.addForm.user),
            callback: function($$v) {
              _vm.$set(_vm.addForm, "user", $$v)
            },
            expression: "addForm.user"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "姓名",
            "prop": "name"
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.addForm.name),
            callback: function($$v) {
              _vm.$set(_vm.addForm, "name", $$v)
            },
            expression: "addForm.name"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "类型",
            "prop": "type"
          }
        }, [_c('el-select', {
          model: {
            value: (_vm.addForm.type),
            callback: function($$v) {
              _vm.$set(_vm.addForm, "type", $$v)
            },
            expression: "addForm.type"
          }
        }, _vm._l((_vm.types), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "密码",
            "prop": "password"
          }
        }, [_c('el-input', {
          attrs: {
            "type": "password",
            "placeholder": "请输入"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.addSubmit.apply(null, arguments)
            }
          },
          model: {
            value: (_vm.addForm.password),
            callback: function($$v) {
              _vm.$set(_vm.addForm, "password", $$v)
            },
            expression: "addForm.password"
          }
        })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.addFormVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.addLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.addSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "编辑",
            "visible": _vm.editFormVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.editFormVisible = $event
            },
            "closed": _vm.closeeditForm
          }
        }, [_c('el-form', {
          ref: "editForm",
          attrs: {
            "model": _vm.editForm,
            "label-width": "80px",
            "rules": _vm.editFormRules
          }
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "账号",
            "prop": "phone"
          }
        }, [_c('el-input', {
          attrs: {
            "disabled": "",
            "auto-complete": "off",
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.editForm.phone),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "phone", $$v)
            },
            expression: "editForm.phone"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "姓名",
            "prop": "name"
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.editForm.name),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "name", $$v)
            },
            expression: "editForm.name"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "类型",
            "prop": "type"
          }
        }, [_c('el-select', {
          model: {
            value: (_vm.editForm.type),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "type", $$v)
            },
            expression: "editForm.type"
          }
        }, _vm._l((_vm.types), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "密码",
            "prop": "password"
          }
        }, [_c('el-input', {
          attrs: {
            "type": "password",
            "auto-complete": "off",
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.editForm.password),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "password", $$v)
            },
            expression: "editForm.password"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "确认密码",
            "prop": "conpassword"
          }
        }, [_c('el-input', {
          attrs: {
            "type": "password",
            "auto-complete": "off",
            "placeholder": "请输入"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.editSubmit.apply(null, arguments)
            }
          },
          model: {
            value: (_vm.editForm.conpassword),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "conpassword", $$v)
            },
            expression: "editForm.conpassword"
          }
        })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.editFormVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.editLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1)]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber,
            "page-size": _vm.pageSize,
            "total": _vm.total
          },
          on: {
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange
          }
        })], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d7422ba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/administrator/admin/Admin.vue
// module id = 1749
// module chunks = 9